module.exports = __webpack_public_path__ + "housingStatic/img/basic_investment.e715a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/basic/basic_investment.png
// module id = qaL+
// module chunks = 2